/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

class ProfileThemeStyle extends React.Component {

  constructor(props) {
    super(props);

    this.clearColorTimeout = this.clearColorTimeout.bind(this);

    this.colorTimeout = null;

    this.state = {
      baseColorA: props.colorTheme.base_color,
      baseColorB: props.colorTheme.base_color,
      highlightColor: props.colorTheme.highlight_color,
      accentColor: props.colorTheme.accent_color,
      animationName: 'profileAnimationA',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const diffR = nextProps.colorTheme.base_color.r !== this.props.colorTheme.base_color.r;
    const diffG = nextProps.colorTheme.base_color.g !== this.props.colorTheme.base_color.g;
    const diffB = nextProps.colorTheme.base_color.b !== this.props.colorTheme.base_color.b;

    if (diffR || diffG || diffB) {
      this.setState({
        baseColorA: this.state.baseColorB,
        baseColorB: nextProps.colorTheme.base_color,
        highlightColor: nextProps.colorTheme.highlight_color,
        accentColor: nextProps.colorTheme.accent_color,
        animationName: this.state.animationName === 'profileAnimationA' ? 'profileAnimationB' : 'profileAnimationA',
      });
    } else {
      this.setState({
        baseColorA: nextProps.colorTheme.base_color,
        baseColorB: nextProps.colorTheme.base_color,
        highlightColor: nextProps.colorTheme.highlight_color,
        accentColor: nextProps.colorTheme.accent_color,
      });
    }
    this.clearColorTimeout();

    this.colorTimeout = setTimeout(() => {
      this.setState({
        baseColorA: nextProps.colorTheme.base_color,
      });
    }, 600);
  }

  componentWillUnmount() {
    this.clearColorTimeout();
  }

  clearColorTimeout() {
    if (this.colorTimeout) {
      clearTimeout(this.colorTimeout);
      this.colorTimeout = null;
    }
  }

  render() {
    const baseColorA = `rgb(${this.state.baseColorA.r}, ${this.state.baseColorA.g}, ${this.state.baseColorA.b})`;
    const baseColorB = `rgb(${this.state.baseColorB.r}, ${this.state.baseColorB.g}, ${this.state.baseColorB.b})`;
    const baseColor10 = `rgba(${this.state.baseColorB.r}, ${this.state.baseColorB.g}, ${this.state.baseColorB.b}, 0.1)`;
    const baseColor5 = `rgba(${this.state.baseColorB.r}, ${this.state.baseColorB.g}, ${this.state.baseColorB.b}, 0.05)`;
    const highlightColor = `rgb(${this.state.highlightColor.r}, ${this.state.highlightColor.g}, ${this.state.highlightColor.b})`;
    const highlightColor25 = `rgb(${this.state.highlightColor.r}, ${this.state.highlightColor.g}, ${this.state.highlightColor.b}, 0.25)`;
    const accentColor = `rgb(${this.state.accentColor.r}, ${this.state.accentColor.g}, ${this.state.accentColor.b})`;

    return (
      <style id="style-profile-theme" type="text/css">
        {
          `@keyframes ${this.state.animationName} {
            from {
              background-color: ${baseColorA};
            }
            to {
              background-color: ${baseColorB};
            }
          }`
        }
        {
          `.profile-background-color,
          .bkgd-color-profile {
            background-color: ${baseColorB} !important;
          }
          .bkgd-color-profile-accent {
            background-color: ${accentColor} !important;
          }
          .profile-border-color,
          .border-color-profile {
            border-color: ${baseColorB} !important;
          }
          .border-color-profile-accent {
            border-color: ${accentColor} !important;
          }
          .border-color-profile-highlight {
            border-color: ${highlightColor} !important;
          }
          .font-color-profile {
            color: ${baseColorB} !important;
          }
          .font-color-profile-highlight {
            color: ${highlightColor} !important;
          }
          .font-color-profile-accent {
            color: ${accentColor} !important;
          }
          .highlight-color-profile {
            fill: ${highlightColor} !important;
          }
          .fill-color-profile {
            fill: ${baseColorB} !important;
          }
          .fill-color-profile-highlight {
            fill: ${highlightColor} !important;
          }
          .fill-color-profile-accent {
            fill: ${accentColor} !important;
          }
          .stroke-color-profile {
            stroke: ${baseColorB} !important;
            fill: none;
          }
          .stroke-color-profile-highlight {
            stroke: ${highlightColor} !important;
            fill: none;
          }
          .stroke-color-profile-accent {
            stroke: ${accentColor} !important;
            fill: none;
          }
          .profile-stroke-fill-color {
            stroke: ${baseColorB} !important;
            fill: ${baseColorB} !important;
          }
          .profile-white-fill-color {
            fill: white !important;
          }

          .profile-background-color-highlight,
          .bkgd-color-profile-highlight {
            background-color: ${highlightColor} !important;
          }
          .profile-background-color-accent {
            background-color: ${accentColor} !important;
          }
          .profile-background-color-10 {
            background-color: ${baseColor10} !important;
          }
          .profile-background-color-10-hover:hover {
            background-color: ${baseColor10} !important;
          }
          .profile-background-color-5 {
            background-color: ${baseColor5} !important;
          }
          .profile-border-bottom-color-10 {
            border-bottom: 1px solid ${baseColor10} !important;
          }
          .profile-border-bottom-color-highlight-25 {
            border-bottom: 1px solid ${highlightColor25} !important;
          }
          .profile-border-top-color-highlight-25 {
            border-top: 1px solid ${highlightColor25} !important;
          }

          .profile-background-color.is-animated {
            animation-name: ${this.state.animationName};
            animation-duration: 0.6s;
            animation-timing-function: ease-out;
          }

          .profile-border-color.is-animated {
            animation-name: ${this.state.animationName};
            animation-duration: 0.6s;
            animation-timing-function: ease-out;
          }

          .font-color-profile.is-animated {
            animation-name: ${this.state.animationName};
            animation-duration: 0.6s;
            animation-timing-function: ease-out;
          }

          .input-range-theme-profile > input[type=range]::-webkit-slider-thumb {
            background-color: ${accentColor};
            border-color: ${highlightColor};
          }
          .input-range-theme-profile > input[type=range]::-moz-range-thumb {
            background-color: ${accentColor};
            border-color: ${highlightColor};
          }
          .input-range-theme-profile > input[type=range]::-ms-thumb {
            background-color: ${accentColor};
            border-color: ${highlightColor};
          }

          @keyframes profile-background-color-animated-flash {
            0% {
              background-color: ${accentColor};
            }
            30% {
              background-color: ${baseColorB};
            }
            100% {
              background-color: ${accentColor};
            }
          }

          @keyframes profile-fill-color-animated-flash {
            0% {
              fill: ${accentColor};
            }
            30% {
              fill: ${baseColorB};
            }
            100% {
              fill: ${accentColor};
            }
          }
          `
        }
      </style>
    );
  }
}
ProfileThemeStyle.propTypes = {
  colorTheme: PropTypes.object,
};

export default ProfileThemeStyle;
